import { Case, Client, Document, Status, Task, User } from '../types';

export const seedUsers: User[] = [
  { id: 'user1', username: 'john.smith', email: 'john@example.com', initials: 'JS' },
  { id: 'user2', username: 'sarah.jones', email: 'sarah@example.com', initials: 'SJ' },
  { id: 'user3', username: 'mike.wilson', email: 'mike@example.com', initials: 'MW' },
];

export const seedCaseStatuses: Status[] = [
  { id: 'active', label: 'Active', color: '#063932' },
  { id: 'review', label: 'In Review', color: '#EC8D18' },
  { id: 'pending', label: 'Pending', color: '#A2B9B5' },
  { id: 'closed', label: 'Closed', color: '#6BBBB1' },
];

export const seedTaskStatuses: Status[] = [
  { id: 'pending', label: 'Pending', color: '#A2B9B5' },
  { id: 'in-progress', label: 'In Progress', color: '#EC8D18' },
  { id: 'completed', label: 'Completed', color: '#063932' },
];

export const seedCases: Case[] = [
  {
    id: 'case1',
    name: 'Contract Dispute - Tech Corp Inc.',
    client: { id: 'client_user1', username: 'Tech Corp Inc.', email: 'contact@techcorp.com', initials: 'TC' },
    status: seedCaseStatuses[0],
    assignedTo: seedUsers[0],
    createdAt: '2024-01-10T10:30:00Z',
    updatedAt: '2024-01-12T14:20:00Z',
  },
  {
    id: 'case2',
    name: 'Merger Agreement Review',
    client: { id: 'client_user2', username: 'Acme Corporation', email: 'legal@acme.com', initials: 'AC' },
    status: seedCaseStatuses[1],
    assignedTo: seedUsers[1],
    createdAt: '2024-01-09T14:20:00Z',
    updatedAt: '2024-01-11T09:15:00Z',
  },
  {
    id: 'case3',
    name: 'Employment Contract Draft',
    client: { id: 'client_user3', username: 'StartupXYZ', email: 'hr@startupxyz.com', initials: 'SX' },
    status: seedCaseStatuses[2],
    createdAt: '2024-01-08T09:15:00Z',
  },
];

export const seedClients: Client[] = [
  {
    id: 'client1',
    name: 'Tech Corp Inc.',
    email: 'contact@techcorp.com',
    phone: '+1 (555) 123-4567',
    casesCount: 5,
    lastContact: '2024-01-12T14:20:00Z',
  },
  {
    id: 'client2',
    name: 'Acme Corporation',
    email: 'legal@acme.com',
    phone: '+1 (555) 234-5678',
    casesCount: 3,
    lastContact: '2024-01-11T09:15:00Z',
  },
  {
    id: 'client3',
    name: 'StartupXYZ',
    email: 'hr@startupxyz.com',
    phone: '+1 (555) 345-6789',
    casesCount: 2,
    lastContact: '2024-01-10T16:45:00Z',
  },
];

// Sample PDF URL for demo (public domain sample)
const SAMPLE_PDF_URL = 'https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf';

export const seedDocuments: Document[] = [
  {
    id: 'doc1',
    name: 'Merger Agreement Draft.pdf',
    type: 'Contract',
    caseId: 'case2',
    caseName: 'Merger Agreement Review',
    uploadedBy: seedUsers[1],
    uploadedAt: '2024-01-09T14:20:00Z',
    size: '2.4 MB',
    url: SAMPLE_PDF_URL,
  },
  {
    id: 'doc2',
    name: 'Client Meeting Notes.docx',
    type: 'Notes',
    caseId: 'case1',
    caseName: 'Contract Dispute - Tech Corp Inc.',
    uploadedBy: seedUsers[0],
    uploadedAt: '2024-01-10T11:00:00Z',
    size: '156 KB',
  },
];

export const seedTasks: Task[] = [
  {
    id: 'task1',
    title: 'Client Meeting Preparation - Q1 Review',
    assignedTo: seedUsers[0],
    dueDate: '2024-01-15T09:00:00Z',
    status: seedTaskStatuses[0],
    priority: 'high',
  },
  {
    id: 'task2',
    title: 'Review Contract Terms',
    assignedTo: seedUsers[1],
    dueDate: '2024-01-14T17:00:00Z',
    status: seedTaskStatuses[1],
    priority: 'urgent',
  },
];

